import React, { useEffect, useMemo, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import CreateNewSpinWheelButton from "./CreateNewSpinWheelButton";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "react-modal";
import SpinWheelDetail from "./SpinWheelDetail";
import SpinWheelService from "../../Services/SpinWheelService";
import { showSuccessToast } from "../../Constant/Notification";
import { ToastContainer } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const SpinWheel = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (location.state?.message) {
      showSuccessToast(location.state.message);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);
  const [spinwheelDetail, setSpinwheelDetail] = useState([]);
  const [logo, setLogo] = useState();
  const [termsAndCondition, setTermsAndCondition] = useState();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role || "";
  const [editButton, setEditButton] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTermAndConditionModalOpen, setIsTermAndConditionModalOpen] =
    useState(false);

  const handleSpinWheelOne = () => {
    if (userRole == "Admin") {
      navigate("/admin/spin-wheel-creation");
    } else if (userRole == "CMO") {
      navigate("/cmo/spin-wheel-creation");
    }
  };
  // const handleSpinWheelTwo =()=>{

  // }
  // const handleSpinWheelThree =()=>{

  // }

  // Custom styles for Modal
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "40%",
      padding: "24px",
      position: "relative",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
    },
  };

  // Bind modal to your appElement
  Modal.setAppElement("#root");

  const handleCloseTermsAndConditionModal = () => {
    setIsTermAndConditionModalOpen(false);
  };
  const handleOpenTermsAndContionModal = async () => {
    try {
      const response = await SpinWheelService.getSpinWheelGeneralInfo();
      console.log(response.data);
      setTermsAndCondition(response.data.termsAndCondition);
      setIsTermAndConditionModalOpen(true);
    } catch (error) {
      console.log(error.response.data);
    }
  };
  const handleOpenWheelLogoUploadModal = async () => {
    try {
      const response = await SpinWheelService.getSpinWheelGeneralInfo();
      console.log(response.data);
      setLogo(response.data.spinWheelLogo);
      setIsModalOpen(true);
    } catch (error) {
      console.log(error.response.data);
    }
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await SpinWheelService.getSpinWheelDetail();
        setSpinwheelDetail(response.data);
      } catch (error) {
        console.error(error.response.data);
      }
      // finally {
      //   setIsLoading(false);
      // }
    };
    fetchData();
  }, []);

  const handleSpinWheelLogoUpload = async (file) => {
    if (!file) return;
    try {
      const formData = new FormData();
      formData.append("file", file);
      const folderPath = "spinWheelLogo";
      const response = await SpinWheelService.createBannerImageTemplate(
        formData,
        folderPath
      );
      const imageUrl = response.data.imageUrl;
      setLogo(imageUrl);
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const handleSetWheelLogo = async () => {
    try {
      const response = await SpinWheelService.setSpinWheelLogo({
        spinWheelLogo: logo,
      });
      console.log(response.data);
      setIsModalOpen(false);
    } catch (error) {
      console.log(error.response.data);
    }
  };
  const handleSetTermsAndCondition = async () => {
    try {
      const response = await SpinWheelService.setSpinWheelLogo({
        termsAndCondition: termsAndCondition,
      });
      console.log(response.data);
      setIsTermAndConditionModalOpen(false);
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const toolbarOptions = useMemo(
    () => [
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["clean"],
    ],
    []
  );

  const module = useMemo(
    () => ({
      toolbar: {
        container: toolbarOptions,

      },
    }),
    [toolbarOptions]
  );
  return (
    <div className="bg-appGrayBackground">
      <AdminAppBar />
      <ToastContainer />
      <div className="pt-16">
        <div className="mt-10 px-20 xl:px-6 relative flex justify-between gap-5">
          <div>
            <h1 className="text-4xl font-semibold whitespace-nowrap ">
              Spin wheel
            </h1>
          </div>

          <div className="flex gap-5">
            <button
              onClick={handleOpenTermsAndContionModal}
              className="border-2 whitespace-nowrap border-customGreen rounded-sm p-1 px-5 w-fit text-lg text-customGreen h-10 text-center"
            >
              Terms and Condition
            </button>

            <button
              onClick={handleOpenWheelLogoUploadModal}
              className="border-2 whitespace-nowrap border-customGreen rounded-sm p-1 px-5 w-fit text-lg text-customGreen h-10 text-center"
            >
              Upload Wheel logo
            </button>
          </div>
        </div>

        <div className="mx-8 flex-col flex gap-8 mt-10">
          {Array.from({ length: 3 }).map((_, index) =>
            index < spinwheelDetail.length ? (
              <SpinWheelDetail
                key={`spinwheel-${index}`}
                spinWheelData={spinwheelDetail[index]}
              />
            ) : (
              <CreateNewSpinWheelButton
                onclick={handleSpinWheelOne}
                key={`button-${index}`}
              />
            )
          )}
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        contentLabel="Wheel logo"
        style={customStyles}
      >
        <button
          onClick={handleCloseModal}
          className="absolute top-5 right-3 text-2xl text-gray-700"
        >
          &times;
        </button>
        <div className="flex justify-between ">
          <h2 className="text-3xl font-semibold mb-4">Wheel Logo</h2>
          <button
            onClick={handleSetWheelLogo}
            className="text-white bg-customGreen  w-20 h-10 mr-5 rounded-lg  text-center "
          >
            Save
          </button>
        </div>

        <input
          id={`fileInput`}
          type="file"
          className="hidden"
          onChange={(e) => handleSpinWheelLogoUpload(e.target.files[0])}
        />
        <label
          htmlFor={`fileInput`}
          className="w-full h-16 flex items-center justify-center border border-gray-300 bg-appGrayBackground rounded-lg cursor-pointer"
        >
          {logo ? (
            <img
              src={logo}
              alt="Preview"
              className="w-full h-full object-contain rounded-lg"
            />
          ) : (
            "Click here to upload logo"
          )}
        </label>
      </Modal>

      {/* <Modal
        isOpen={isTermAndConditionModalOpen}
        onRequestClose={handleCloseTermsAndConditionModal}
        contentLabel="Terms and Conditions"
        style={customStyles}
      >


        <button
          onClick={handleCloseTermsAndConditionModal}
          className="absolute top-5 right-3 text-2xl text-gray-700"
        >
          &times;
        </button>
        <div className='flex justify-between '>

        <h2 className="text-3xl font-semibold mb-4">Terms & Conditions</h2>


        {editButton ? (<>
        <div>
        <button onClick ={()=>setEditButton(false)} className='text-customGreen bg-transparent border-2 border-customGreen  w-20 h-10 mr-5 rounded-lg  text-center '>
          Cancel
        </button>
        <button onClick ={handleSetTermsAndCondition} className='text-white bg-customGreen  w-20 h-10 mr-5 rounded-lg  text-center '>
          Save
        </button>
        </div>
        </>):( <button onClick ={()=>setEditButton(true)} className='text-white bg-customGreen  w-20 h-10 mr-5 rounded-lg  text-center '>
          Edit
        </button>)}
        </div>
{editButton ? (

<textarea onChange={(e)=>setTermsAndCondition(e.target.value)}  className='border border-gray-400 focus:ouline-none bg-[#F6F6F6] w-full h-[300px] p-2 rounded-xl ' name="" id="">{termsAndCondition}</textarea>

):(
  <textarea onChange={(e)=>setTermsAndCondition(e.target.value)} readOnly className='border border-gray-400 focus:ouline-none cursor-pointer bg-[#F6F6F6] w-full h-[300px] p-2 rounded-xl ' name="" id="">{termsAndCondition}</textarea>

)}


        </Modal> */}

      <Modal
        isOpen={isTermAndConditionModalOpen}
        onRequestClose={handleCloseTermsAndConditionModal}
        contentLabel="Terms and Conditions"
        style={customStyles}
      >
        <button
          onClick={handleCloseTermsAndConditionModal}
          className="absolute top-5 right-3 text-2xl text-gray-700"
        >
          &times;
        </button>
        <div className="flex justify-between">
          <h2 className="text-3xl font-semibold mb-4">Terms & Conditions</h2>

          {editButton ? (
            <>
              <div>
                <button
                  onClick={() => setEditButton(false)}
                  className="text-customGreen bg-transparent border-2 border-customGreen w-20 h-10 mr-5 rounded-lg text-center"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSetTermsAndCondition}
                  className="text-white bg-customGreen w-20 h-10 mr-5 rounded-lg text-center"
                >
                  Save
                </button>
              </div>
            </>
          ) : (
            <button
              onClick={() => setEditButton(true)}
              className="text-white bg-customGreen w-20 h-10 mr-5 rounded-lg text-center"
            >
              Edit
            </button>
          )}
        </div>

        {editButton ? (
          <ReactQuill
            value={termsAndCondition}
            modules={module}
            onChange={setTermsAndCondition}
            className="focus:outline-none bg-[#F6F6F6] w-full h-[300px] p-2 rounded-xl border-none"
            // className="border border-gray-400 focus:outline-none bg-[#F6F6F6] w-full h-[300px] p-2 rounded-xl"
          />
        ) : (
          <ReactQuill
            value={termsAndCondition}
            readOnly
            modules={module}
            className="focus:outline-none bg-[#F6F6F6] w-full  p-2 rounded-xl border-none"
            // className="border border-gray-400 focus:outline-none cursor-pointer bg-[#F6F6F6] w-full h-[300px] p-2 rounded-xl"
          />
        )}
      </Modal>
    </div>
  );
};

export default SpinWheel;
